import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Leaf, Lock } from "lucide-react";
import api, { apiErr } from "../lib/api";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Label } from "../components/ui/label";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { toast.error("Passwords don't match."); return; }
    if (!token) { toast.error("This reset link is missing its token."); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. You can sign in now.");
      navigate("/auth");
    } catch (err) { toast.error(apiErr(err)); }
    setLoading(false);
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-b from-[#8FB8DE]/20 to-background px-4 py-10">
      <div className="w-full max-w-md">
        <div className="mb-6 flex items-center justify-center gap-2">
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-[#4A7c59] text-white"><Leaf strokeWidth={1.8} className="h-5 w-5" /></div>
          <span className="font-head text-2xl font-bold text-[#2C363F]">TaperPath</span>
        </div>
        <div className="rounded-2xl border border-border bg-white p-8 shadow-xl shadow-[#4A7c59]/5">
          <h1 className="font-head text-xl font-bold text-[#2C363F]">Choose a new password</h1>
          <form onSubmit={submit} className="mt-5 space-y-4">
            <div>
              <Label className="text-sm">New password</Label>
              <div className="relative mt-1"><Lock className="absolute left-3 top-3.5 h-4 w-4 text-muted-foreground" />
                <Input data-testid="reset-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="At least 6 characters" className="rounded-xl py-6 pl-10" /></div>
            </div>
            <div>
              <Label className="text-sm">Confirm password</Label>
              <div className="relative mt-1"><Lock className="absolute left-3 top-3.5 h-4 w-4 text-muted-foreground" />
                <Input data-testid="reset-confirm" type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="Re-enter password" className="rounded-xl py-6 pl-10" /></div>
            </div>
            <Button data-testid="reset-submit" type="submit" disabled={loading} className="w-full rounded-full bg-[#4A7c59] py-6 text-base font-semibold hover:bg-[#3B6347]">
              {loading ? "Please wait…" : "Update password"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
